import React from "react";
import $ from "jquery";
import "./Styles/Home.css";
export default function Home() {
  
  // words to switch between
  var words = ['Dynamic websites', '🖧 Networking 🖧', 'Technology', 'Making apps', '⚙️ Gadgets ⚙️', '🕹️Gaming🕹️', 'Designing'];
  
  $(document).ready(() => {
    $(".container-flex").fadeIn(2000)
    const change = $(".change")
   
    setInterval(function next() {
      var num = Math.floor((Math.random() * 6) + 0);
      change.text(words[num]);
      //console.log(num)
    }, 10000);
  });
  return (
    <div>
      <div className="container mt-5 hide">
        <br/><br/>
        <div className="row justify-content-center ">
          <div className=" col-sm-12 col-md-9 ">
            <h1 className="text-center p-3 ">Hey! I'm Darius and I 💓</h1>
            <h1 className="text-center p-3 change">Technology</h1>
          </div>
        </div>
        <div className="row justify-content-center m-5">
          <div className="col-sm-12 col-md-4 card-box">
            <img
              className="img-responsive mx-auto"
              height="250px"
              src="./Images/gif_logo.gif"
              alt="./Images/gif_logo.gif"
            />
          </div>
          <div className="col-sm-12 col-md-4 card-box ">
            <h1>Resume</h1>
            <a target="_blank" rel="noreferrer" href="https://docs.google.com/document/d/1NAZlWzrKhIncWEyIT6DWgcUsOteur_7v_I9aa6qfSRs/edit?usp=sharing">
            <img
              className="w-100 mx-auto text-center mt-3"
              src="./Images/resume.svg"
              alt=""
            />
            </a>
          </div>
          <div className="col-sm-12 col-md-4 card-box mt-3 ">
            <h1>Projects</h1>
            <a className="d-block p-3 " target="_blank" href="https://dev6636.d3efg0hik4r4k1.amplifyapp.com/">Tasties</a>
            <a className="d-block p-3" target="_blank"href="https://www.dpcores.com/movies">Rumdone Movies</a>
            <a className="d-block p-3 " target="_blank" href="https://dev4245.d1phzvze0f0l09.amplifyapp.com">BBQ site</a>
            {/* <a className="d-block p-3 " href="https://webprofile.d39ose37ksgy0r.amplifyapp.com/Projects">All👉</a> */}
          </div>
        </div>
        <br />
        <br />
        <div className="row ">
          <div className="col-sm-12 col-md-6 intro p-3">
            <h1>Work</h1>
            <p>
              I am a technician/designer on board The Allure of the Seas. I
              maintain serveral Konica 3070s/3080s printing presses while keeping
              track/order items for the printshop's inventory. I also help
              design and update the ship's compasses (daily activities,shows etc).
            </p>
          </div>
          <div className="col-sm-12 col-md-6 intro p-3">
            <h1>Fun</h1>
            <p>
              When Im not in the printshop, I am always trying new foods and
              getting lost in the different locations across the world. My Go Pro and
              bepbop 2 are always along for the adventure so I can capture
              footage for my upcoming <a className="text-center"target="_blank" href="https://www.youtube.com/playlist?list=PLC5SzhYSJEFdazhKn3PTntCfAXtQjFFjQ">Youtube channel</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
